<form
  (ngSubmit)="onSubmit()"
  [formGroup]="form"
  class="flex items-center justify-center flex-col gap-8 min-w-[300px]"
>
  <div class="flex flex-col gap-4 w-full">
    <input type="text" name="username" autocomplete="username" hidden />
    <p-inputgroup class="mt-2">
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="oldPassword"
            formControlName="oldPassword"
            autocomplete="current-password"
            [type]="currentPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="currentPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
            (click)="toggleCurrentPasswordVisibility()"
          />
        </p-iconfield>
        <label for="oldPassword" i18n>Current Password</label>
      </p-floatLabel>
    </p-inputgroup>

    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="newPassword"
            autocomplete="new-password"
            formControlName="newPassword"
            [type]="newPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="newPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
            (click)="toggleNewPasswordVisibility()"
          />
        </p-iconfield>
        <label for="newPassword" i18n>New Password</label>
      </p-floatLabel>
    </p-inputgroup>
    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="far fa-key"></i>
      </p-inputgroup-addon>
      <p-floatLabel class="w-full" variant="on">
        <p-iconfield>
          <input
            pInputText
            id="confirmNewPassword"
            autocomplete="new-password"
            formControlName="confirmNewPassword"
            [type]="confirmNewPasswordVisible ? 'text' : 'password'"
          />
          <p-inputicon
            class="cursor-pointer"
            [class]="
              confirmNewPasswordVisible ? 'far fa-eye' : 'far fa-eye-slash'
            "
            (click)="toggleConfirmNewPasswordVisibility()"
          />
        </p-iconfield>
        <label for="confirmNewPassword" i18n>Confirm New Password</label>
      </p-floatLabel>
    </p-inputgroup>
  </div>
  <div>
    <p-button label="Change Password" type="submit" i18n-label />
  </div>
</form>
